import { useApiGet } from '../../shared/api/utils/reactQueryProvider';
import { getLiveAlerts } from '../api/services/Rides';
import { LiveAlertDetails } from '../types/alert';

interface IUseLiveAlertsQuery {
  rideSlug: string;
}

export const LIVE_ALERTS_QUERY_KEY = 'liveAlerts';

export const useLiveAlertsQuery = ({ rideSlug }: IUseLiveAlertsQuery) => {
  return useApiGet<{ data: LiveAlertDetails[] }>([LIVE_ALERTS_QUERY_KEY, rideSlug], () => getLiveAlerts(rideSlug), {
    enabled: true,
  });
};
